import React, { useEffect } from "react"
import { BrowserRouter as Router, useNavigate } from "react-router-dom"
import MainRoutes from "./routes/MainRoutes"
import ToastManager from "./components/toast/ToastManager"

import { AuthProvider } from "./context/AuthContext"

function AppContent() {
  const navigate = useNavigate()

  useEffect(() => {
    const handleAuthRedirect = (event) => {
      navigate(event.detail)
    }

    window.addEventListener("auth-redirect", handleAuthRedirect)

    return () => {
      window.removeEventListener("auth-redirect", handleAuthRedirect)
    }
  }, [navigate])

  useEffect(() => {
    const isDevToolEnable = process.env.REACT_APP_ENABLE_DEV_TOOLS === "true"

    if (!isDevToolEnable) {
      const handleContextMenu = (e) => e.preventDefault()
      const handleKeyDown = (e) => {
        // Example: Block Ctrl+Shift+I, F12
        if ((e.ctrlKey && e.shiftKey && e.key === "I") || e.key === "F12") {
          e.preventDefault()
        }
      }

      document.addEventListener("contextmenu", handleContextMenu)
      document.addEventListener("keydown", handleKeyDown)

      return () => {
        document.removeEventListener("contextmenu", handleContextMenu)
        document.removeEventListener("keydown", handleKeyDown)
      }
    }
  }, [])

  const disableRightClick = (event) => {
    event.preventDefault()
  }

  const blockDeveloperShortcuts = (event) => {
    const key = event.key.toUpperCase()
    const isMac = navigator.platform.toUpperCase().includes("MAC")

    // Define blocked combinations
    const isBlockedKeyCombo =
      key === "F12" || // F12
      (event.ctrlKey && event.shiftKey && ["I", "J", "C"].includes(key)) || // Ctrl+Shift+I/J/C
      (event.ctrlKey && key === "U") || // Ctrl+U
      (isMac &&
        ((event.metaKey && event.altKey && ["I", "J", "C"].includes(key)) || // Cmd+Option+I/J/C
          (event.metaKey && event.shiftKey && key === "C") || // Cmd+Shift+C
          (event.metaKey && key === "U"))) // Cmd+U

    if (isBlockedKeyCombo) {
      event.preventDefault()
      event.stopImmediatePropagation()
      return false
    }
  }

  return (
    <>
      <ToastManager />
      <MainRoutes />
    </>
  )
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <AppContent />
      </Router>
    </AuthProvider>
  )
}

export default App
